/**
 * Handles s shader object type.
 */
export enum HsShaderObjectType {
  single,
  collection,
}
